import { render, staticRenderFns } from "./section.vue?vue&type=template&id=2024f620&"
import script from "./section.vue?vue&type=script&lang=ts&"
export * from "./section.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ESectionTitle: require('/var/lib/jenkins/workspace/e-world-nuxt/components/e/sectionTitle.vue').default})
